<span [ngClass]="containerClass()">
  <mat-button-toggle-group hideSingleSelectionIndicator="true">
    <mat-button-toggle
      class="split-button-2"
      [disabledInteractive]="true"
      [disableRipple]="true"
      [matTooltip]="tooltip()"
      [attr.aria-label]="tooltip()"
    >
      @if (icon()) {
        <mat-icon>{{ icon() }}</mat-icon>
      }
      {{ label() }}
    </mat-button-toggle>
    <mat-button-toggle
      class="split-button-2 drop-down-button"
      [matMenuTriggerFor]="dropdownMenuTwo"
      matTooltip="Altre opzioni"
      aria-label="Altre opzioni"
    >
      <mat-icon>keyboard_arrow_down</mat-icon>
    </mat-button-toggle>
  </mat-button-toggle-group>
  <mat-menu #dropdownMenuTwo="matMenu" style="width: 200px">
    @for (opt of options() ?? []; track $index) {
      <button
        mat-menu-item
        class="font-normal split-button-item mw-[140px]"
        (click)="onToggleOptions(opt)"
        [attr.aria-label]="opt"
      >
        {{ opt }}
      </button>
    }
  </mat-menu>
</span>
